import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import Autosuggest from 'react-autosuggest';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';

import {HelpButton} from '../../common/button';

import styles from '../../common/styles';

class AutoComplete extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleSuggestionsClearRequested = this.handleSuggestionsClearRequested.bind(this);
        this.handleSuggestionsFetchRequested = this.handleSuggestionsFetchRequested.bind(this);
        this.renderInput = this.renderInput.bind(this);
        this.renderAutosuggest = this.renderAutosuggest.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);

        this.state = {
            suggestions: []
        };

        this.debouncedFetch = !!props.fetchData ? _.debounce(props.fetchData, 500) : null;
    }

    handleSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    };

    handleSuggestionsFetchRequested({value}) {
        if (!this.debouncedFetch) {
            const inputValue = value.trim().toLowerCase();
            const inputLength = inputValue.length;
            const suggestions = inputLength === 0 ? [] : this.props.options.filter(option =>
                option.key.toLowerCase().slice(0, inputLength) === inputValue
            );
            this.setState({suggestions});
        } else if (value && value.length > 2) {
            this.debouncedFetch(value);
        }
    };

    renderInput({disabled, fetchData, field, helpButton, input, label, messageId, meta, meta: {active, error, touched, warning}, ref, type, ...rest}) {
        return (
            <FormControl disabled={disabled} fullWidth>
                <InputLabel htmlFor={field} shrink>
                    {messageId ? <FormattedMessage id={messageId}/> : label}
                    {helpButton && !React.isValidElement(helpButton) ? <HelpButton {...helpButton}/> : helpButton}
                </InputLabel>
                <Input
                    id={field}
                    inputRef={ref}
                    spellCheck
                    type={type}
                    {...input}
                    {...rest}
                />
                <FormHelperText error={!!error ? !!error : undefined}>
                    {do {
                        if (touched && !!error) {
                            error;
                        } else if (active && touched && !error && !!warning) {
                            warning;
                        }
                    }}
                </FormHelperText>
            </FormControl>
        );
    }

    renderAutosuggest({input, options, ...rest}) {
        return (
            <Autosuggest
                renderInputComponent={this.renderInput}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                suggestions={this.props.fetchData ? options : this.state.suggestions}
                onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                getSuggestionValue={suggestion => `${suggestion.key}`}
                renderSuggestion={this.renderSuggestion}
                inputProps={{
                    value: Number.isInteger(input.value) ? `${input.value}` : input.value,
                    onChange: (e, {newValue}) => input.onChange(newValue),
                    ...rest
                }}
                {...styles.autoSuggest()}
            />
        );
    }

    renderSuggestion(suggestion, { query, isHighlighted }) {
        return (
            <MenuItem selected={isHighlighted} component="div">
                {suggestion.text}
            </MenuItem>
        );
    }

    renderSuggestionsContainer(options) {
        const {containerProps, children} = options;
        return (
            <Paper {...containerProps} square>
                {children}
            </Paper>
        );
    }

    render() {
        const {field, label, ...rest} = this.props;
        return (
            <span className="input">
                <Field
                    component={this.renderAutosuggest}
                    label={label}
                    name={field}
                    {...rest}
                />
            </span>
        );
    }
}

AutoComplete.propTypes = {
    fetchData: PropTypes.func,
    field: PropTypes.string.isRequired,
    filter: PropTypes.func,
    helpButton: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.object
    ]),
    hintText: PropTypes.string,
    label: PropTypes.string,
    messageId: PropTypes.string,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string
};

export default AutoComplete;


// WEBPACK FOOTER //
// ./src/components/common/form/AutoComplete.js